export function searchPrintTemplate(data) {
    return abp.ajax({
        url: '/api/services/app/PrintTemplate/Search',
        method: 'post',
        data: data
    });
}

export function createPrintTemplate(data) {
    return abp.ajax({
        url: '/api/services/app/PrintTemplate/CreateAsync',
        method: 'post',
        data: data
    });
}

export function deletePrintTemplate(id) {
    return abp.ajax({
        url: '/api/services/app/PrintTemplate/DeleteAsync',
        method: 'delete',
        params: { id:id }
    });
}
